/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Subscriptionmanagement2Inputs */

const zh_settingsnav_subscriptionmanagement2 = /** @type {(inputs: Settingsnav_Subscriptionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

const en_settingsnav_subscriptionmanagement2 = /** @type {(inputs: Settingsnav_Subscriptionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Management`)
};

const es_settingsnav_subscriptionmanagement2 = /** @type {(inputs: Settingsnav_Subscriptionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de suscripciones`)
};

/**
* | output |
* | --- |
* | "Subscription Management" |
*
* @param {Settingsnav_Subscriptionmanagement2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_subscriptionmanagement2 = /** @type {((inputs?: Settingsnav_Subscriptionmanagement2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Subscriptionmanagement2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_subscriptionmanagement2(inputs)
	if (locale === "en") return en_settingsnav_subscriptionmanagement2(inputs)
	return es_settingsnav_subscriptionmanagement2(inputs)
});
export { settingsnav_subscriptionmanagement2 as "settingsNav_subscriptionManagement" }